import {
  CrmAccountInfo,
  CrmConnection,
  CrmConnectionId,
  CrmConnectionMin,
  CreateCrmConnection,
  ExternalAuthorizationId,
  UpdateCrmConnection,
  CrmConnector,
} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function listConnectors(): Promise<CrmConnector[]> {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/crm_connectors`, {});
}

export async function getConnector(connectorId: string): Promise<CrmConnector> {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/vendor_toolkit/crm_connectors/{crm_connector_id}`,
    {path: {crm_connector_id: connectorId}},
  );
}

export async function getAccountInfo(
  connectorId: string,
  externalAuthorizationId: ExternalAuthorizationId,
): Promise<CrmAccountInfo> {
  return await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/crm_connectors/{crm_connector_id}/account_info`,
    {body: externalAuthorizationId, path: {crm_connector_id: connectorId}},
  );
}

export async function list(): Promise<CrmConnectionMin[]> {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/crm_connections`, {});
}

export async function get(connectionId: CrmConnectionId): Promise<CrmConnection> {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/vendor_toolkit/crm_connections/{crm_connection_id}`,
    {path: {crm_connection_id: connectionId}},
  );
}

export async function create(connection: CreateCrmConnection): Promise<CrmConnection> {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/vendor_toolkit/crm_connections`, {
    body: connection,
  });
  await invalidateQueries([q.vendorToolkit.crmConnections.filter()]);
  return res;
}

export async function updateName(connectionId: CrmConnectionId, name: string) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/crm_connections/{crm_connection_id}/name`,
    {body: name, path: {crm_connection_id: connectionId}},
  );
  await invalidateQueries([
    q.vendorToolkit.crmConnection.filter(connectionId),
    q.vendorToolkit.crmConnections.filter(),
  ]);
  return res;
}

export async function update(connectionId: CrmConnectionId, update: UpdateCrmConnection) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/crm_connections/{crm_connection_id}`,
    {body: update, path: {crm_connection_id: connectionId}},
  );
  await invalidateQueries([
    q.vendorToolkit.crmConnection.filter(connectionId),
    q.vendorToolkit.crmConnections.filter(),
  ]);
  return res;
}

export async function sync(connectionId: CrmConnectionId) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/crm_connections/{crm_connection_id}/sync`,
    {path: {crm_connection_id: connectionId}},
  );
  await invalidateQueries([
    q.vendorToolkit.crmConnection.filter(connectionId),
    q.vendorToolkit.crmConnections.filter(),
  ]);
  return res;
}
